import React, { useState } from 'react';
import api from '../utils/api';
import Reveal from '../components/common/Reveal';
import { SectionHeader, BtnPrimary, Card, Pill, FormGroup, inputStyle } from '../components/ui';
import { CATEGORIES } from '../utils/constants';

export default function SubmitArticlePage() {
  const [form, setForm] = useState({ name: '', email: '', title: '', content: '', category: 'Sufism' });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    if (!form.name || !form.email || !form.title || !form.content) return setError('All fields are required.');
    try {
      await api.post('/articles/submit', form);
      setSuccess(true);
      setForm({ name: '', email: '', title: '', content: '', category: 'Sufism' });
    } catch { setError('Submission failed. Try again.'); }
  };

  return (
    <div>
      <div style={{ padding: '120px 40px 40px', textAlign: 'center', background: 'linear-gradient(160deg,var(--cream),var(--soft-orange))' }}>
        <SectionHeader title="Submit an" accent="Article" sub="Share your writing on Sufism, Literature, Art & Culture" />
      </div>
      <section style={{ padding: '40px 40px 80px', maxWidth: 640, margin: '0 auto' }}>
        {success ? (
          <Reveal><Card style={{ padding: 48, textAlign: 'center' }}>
            <div style={{ fontSize: 56, marginBottom: 16 }}>✨</div>
            <h3 className="serif" style={{ fontSize: '1.5rem', marginBottom: 8 }}>Article Submitted!</h3>
            <p style={{ color: 'var(--brown)' }}>Our editorial team will review and publish it. Thank you!</p>
          </Card></Reveal>
        ) : (
          <Reveal><Card style={{ padding: 32 }}>
            {error && <div style={{ padding: '12px 16px', borderRadius: 10, background: '#FEE2E2', color: '#991B1B', marginBottom: 16, fontSize: 14 }}>{error}</div>}
            <FormGroup label="Your Name *"><input style={inputStyle} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Full name" /></FormGroup>
            <FormGroup label="Email *"><input type="email" style={inputStyle} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="your@email.com" /></FormGroup>
            <FormGroup label="Category">
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {CATEGORIES.map(c => <Pill key={c} active={form.category === c} onClick={() => setForm({ ...form, category: c })} style={{ fontSize: 13, padding: '6px 16px' }}>{c}</Pill>)}
              </div>
            </FormGroup>
            <FormGroup label="Title *"><input style={inputStyle} value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="Article title" /></FormGroup>
            <FormGroup label="Content *"><textarea style={{ ...inputStyle, minHeight: 200, resize: 'vertical' }} value={form.content} onChange={e => setForm({ ...form, content: e.target.value })} placeholder="Write your article here..." /></FormGroup>
            <BtnPrimary onClick={submit} style={{ width: '100%', justifyContent: 'center' }}>Submit for Review</BtnPrimary>
            <p style={{ fontSize: 12, color: '#999', marginTop: 12, textAlign: 'center' }}>Articles are reviewed before publishing.</p>
          </Card></Reveal>
        )}
      </section>
    </div>
  );
}
